import * as React from "react";

import i18next from "i18next";

import { BusIcon } from "svg";

import { IconWrapper, Nav, StyledNavLink } from "./styles";

const ManageDistributorsNavItem = ({ isVisible }: { isVisible: boolean }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Nav.Item>
      <StyledNavLink to="/manage-distributors">
        <IconWrapper>
          <BusIcon />
        </IconWrapper>
        {i18next.t("distributors")}
      </StyledNavLink>
    </Nav.Item>
  );
};

export default ManageDistributorsNavItem;
